module.exports = __webpack_public_path__ + "img/exportXjmm.77a76e90.svg";